<template>
  <section class="sec-post-image" v-if="!!image">
    <div :class="container">
      <div class="td-salon__image td-salon__image--full">
        <img :src="image" alt="image">
      </div>
      <div v-if="!!note" class="sec-content__image-text" :class="{'container-middle': container === 'no-container'}"> <!-- container-small -->
        <p>{{note}}</p>
      </div>
    </div>
  </section>
</template>

<script>
import mixin from '@/mixins/sections/styleSettings'
import getBlogImg from "@/helpers/getBlogImg";
export default {
  mixins: [mixin],
  computed: {
    // hasData to be in mixin
    image() {
      return getBlogImg(this.hasData.img && this.hasData.img.file_name,'big')
    },
    note() {
      return this.hasData.note
    },
  }
}
</script>
